import type EditSkiPassViewModel from "@/queries/models/EditPass"
import type { SkiPassItem } from "@/types/Cart"
import type { PassHolderFormState } from "@/types/PassHolder"

const mapFormStateToEditItem = (
  formState: PassHolderFormState,
  data: EditSkiPassViewModel
): SkiPassItem => {
  const { cartItem } = data

  const exitingPhotoId =
    formState.exitingPhotoId !== null && formState.exitingPhotoId !== undefined
      ? formState.exitingPhotoId
      : null
  const newPhotoFileId = exitingPhotoId
    ? null
    : formState.passHolderImage?.id || null

  const originalCertificateId = cartItem.existingCertificateId || null
  const newCertificateId = formState.personCertificate?.id || null
  const certificateUnchanged =
    newCertificateId !== null && newCertificateId === originalCertificateId

  const exitingCertificateId = certificateUnchanged
    ? originalCertificateId
    : null
  const newCertificateFileId = certificateUnchanged ? null : newCertificateId

  const hasCoupon =
    !!formState.memberCoupon?.couponCode && !!formState.memberCoupon?.customerId

  const originalHadCoupon = !!cartItem.mySkistarUserCoupon
  const couponRemoved = originalHadCoupon && !hasCoupon

  const baseItem: SkiPassItem = {
    id: formState.passHolder.id,
    loadSkipass: formState.passSelection === "existing",
    skipassNumber: formState.wtpNumber || "",
    newPhotoFileId,
    newCertificateFileId,
    firstName: formState.passHolder.firstName,
    lastName: formState.passHolder.lastName,
    birthDate: formState.passHolder.birthDate,
    productId: formState.productId,
    resortId: formState.resortId,
    arrivalDate: cartItem.arrivalDate,
    insurance: formState.insurance ?? false,
    bookingLength: formState.bookingLengthInDays,
    birthdateUpdatedOnLoad: false,
    firstNameUpdatedOnLoad: false,
    lastNameUpdatedOnLoad: false,
    exitingPhotoId,
    exitingCertificateId,
    isSubscriptionProduct: formState.isSubscriptionProduct ?? false,
    subscriptionConfigurationId: formState.subscriptionConfigurationId ?? null,
  }

  if (hasCoupon) {
    baseItem.mySkistarUserCoupon = {
      firstName: formState.passHolder.firstName,
      lastName: formState.passHolder.lastName,
      birthDate: formState.passHolder.birthDate,
      couponCode: formState.memberCoupon?.couponCode ?? "",
      couponDesc: formState.memberCoupon?.couponDesc ?? "",
      customerId: formState.memberCoupon?.customerId ?? 0,
    }
  }

  if (couponRemoved && cartItem.mySkistarUserCoupon) {
    baseItem.removedMySkistarUserCoupon = {
      firstName: cartItem.mySkistarUserCoupon.firstName,
      lastName: cartItem.mySkistarUserCoupon.lastName,
      birthDate: cartItem.mySkistarUserCoupon.birthDate ?? "",
      couponCode: cartItem.mySkistarUserCoupon.couponCode,
      couponDesc: cartItem.mySkistarUserCoupon.couponDesc,
      customerId: cartItem.mySkistarUserCoupon.customerId ?? 0,
    }
  }

  return baseItem
}

export default mapFormStateToEditItem
